module.exports = __webpack_public_path__ + "img/unlock.58ddd239.svg";